
import { useNavigation } from '@react-navigation/native';
import { APIData } from '../constants';
import useRest from './base/useRest';

// CONTACTS

const preffix = "account-types";

export const useAccountType = (options?: APIData) => {
    return useRest(`${preffix}/`, options);
};